import { Controller } from '@hotwired/stimulus';

/**
 * Clipboard - copies the source input's value and briefly confirms on the button.
 * Targets: source (input) | button
 * Values:  copiedLabel (String) - text shown on the button after copying
 */
export default class extends Controller {
  static targets = ['source', 'button'];
  static values = { copiedLabel: { type: String, default: 'Copied' } };

  async copy () {
    const text = this.sourceTarget.value;
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      this.sourceTarget.select();
      document.execCommand('copy');
    }

    const original = this.buttonTarget.textContent;
    this.buttonTarget.textContent = this.copiedLabelValue;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => { this.buttonTarget.textContent = original; }, 1500);
  }

  disconnect () {
    clearTimeout(this.timeout);
  }
}
